import React from "react"
import styled from "styled-components"
import { RecipePrice } from "../../Kiosk/style"

const MenuName = styled.h2`
    color: ${({ theme }) => theme.header_background};
    margin-right: 10px;
`

const MenuPrice = (props) => {
    let priceInt, priceSup

    if (props.items.price_currency) {
        const priceRegex = /(\d+)[,|.](\d+)(.*)/
        const priceMatches = priceRegex.exec(props.items.price_currency)

        priceInt = priceMatches[1]
        const decimals= parseInt(priceMatches[2]) !== 0 ? priceMatches[2] : ''
        priceSup = priceMatches[3].trim() + decimals
    }
    if (props.items.price) {
        const priceArray = props.items.price.toString().split('.')
        priceInt = priceArray[0].toString() + props.items.currency
        priceSup = priceArray[1]
            ? priceArray[1].length > 1
                ? priceArray[1]
                : `${priceArray[1]}0`
            : '00'
    }

    return props.items.price ||
        (props.items.price_currency && props.menu) ? (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <MenuName>
                {props.items.name || props.items.menu_label}
            </MenuName>
            <RecipePrice>
                <span>
                    {priceInt}
                    <span>{priceSup}</span>
                </span>
            </RecipePrice>
        </div>
    ) : null
}

export default MenuPrice